import { NgModule } from '@angular/core';
import { SchemaItemComponent} from './schema-item.component'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';  

@NgModule({
    imports: [ FormsModule,MatCheckboxModule,CommonModule],
    declarations: [
        // EnvironmentItemComponent,
        SchemaItemComponent
    ],
    entryComponents: [
        SchemaItemComponent
    ],
    exports: [
        SchemaItemComponent
    ]
})
export class SchemaItemModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/schema-item/schema-item.module.ts